const COLUMN_WIDTH = 150;
const WIDTH_DIFFERENCE = 24;

export const getColumns = ({ vendorTitle }) => {
	return [
		{
			headerName: vendorTitle,
			cellClass: 'vendor-title',
			field: 'vendorName',
			minWidth: COLUMN_WIDTH + WIDTH_DIFFERENCE,
			width: COLUMN_WIDTH + WIDTH_DIFFERENCE,
		},
		{
			headerName: 'Spend',
			field: 'spend',
			minWidth: 164,
			width: 164,
			type: 'numericColumn',
			headerClass: 'ag-numeric-header',
			cellStyle: { direction: 'rtl' },
		},
		{
			headerName: 'Top L4 category',
			field: 'category',
			minWidth: COLUMN_WIDTH - 40,
			width: COLUMN_WIDTH - 40,
			cellClass: 'categories-column',
		},
		{
			headerName: '',
			field: 'category',
			minWidth: 40,
			width: 40,
			lockVisible: true,
			cellRenderer: 'categoriesCellRenderer',
		},
	];
};
